import React, { useState } from 'react';
import RepairCategories from '../RepairCategories';

function CategoryModal({ 
  onClose, 
  onSubmit, 
  currentCategories = [] 
}) {
  const [categories, setCategories] = useState(currentCategories);
  const [newCategory, setNewCategory] = useState({
    category: '',
    subcategory: '',
    estimatedTime: ''
  });

  const handleAddCategory = () => {
    if (newCategory.category && newCategory.subcategory && newCategory.estimatedTime) {
      setCategories([...categories, { ...newCategory }]);
      setNewCategory({
        category: '',
        subcategory: '',
        estimatedTime: ''
      });
    }
  };

  const handleRemoveCategory = (index) => {
    setCategories(categories.filter((_, i) => i !== index));
  };

  const handleChange = ({ category, subcategory }) => {
    setNewCategory(prev => ({
      ...prev,
      category,
      subcategory
    }));
  };

  return (
    <div className="tt-modal-backdrop">
      <div className="tt-modal tt-modal--wide">
        <div className="tt-modal-header">
          <h2 className="tt-modal-title">Repair Categories</h2>
          <button className="tt-modal-close" onClick={onClose}>×</button>
        </div>

        <div className="tt-modal-body">
          {categories.length > 0 && (
            <div style={{ marginBottom: '20px' }}>
              <div className="tt-label">Current Categories</div>
              {categories.map((cat, index) => (
                <div key={index} style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '10px 12px',
                  marginBottom: '8px',
                  backgroundColor: 'var(--tt-surface-2)',
                  border: '1px solid var(--tt-line)',
                  borderRadius: 'var(--rk-radius-sm)'
                }}>
                  <span>{cat.category} - {cat.subcategory} ({cat.estimatedTime}h)</span>
                  <button
                    className="tt-button tt-button--danger"
                    onClick={() => handleRemoveCategory(index)}
                    style={{ minHeight: '28px', padding: '5px 10px' }}
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
          )}

          <div style={{ marginBottom: '20px' }}>
          <div className="tt-label">Add New Category</div>
          <RepairCategories
            selectedCategory={newCategory.category}
            selectedSubcategory={newCategory.subcategory}
            onChange={handleChange}
          />
          
          <div style={{ marginTop: '12px' }}>
            <label>
              Estimated Time (hours):
              <input
                className="tt-input"
                type="number"
                step="0.5"
                min="0"
                value={newCategory.estimatedTime}
                onChange={(e) => setNewCategory(prev => ({
                  ...prev,
                  estimatedTime: e.target.value
                }))}
              />
            </label>
          </div>

          <button
            className="tt-button tt-button--primary"
            onClick={handleAddCategory}
            disabled={!newCategory.category || !newCategory.subcategory || !newCategory.estimatedTime}
            style={{ marginTop: '10px' }}
          >
            Add Category
          </button>
        </div>
        </div>

        <div className="tt-modal-footer">
          <button
            onClick={onClose}
            className="tt-button tt-button--ghost"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              onSubmit(categories);
              onClose();
            }}
            className="tt-button tt-button--primary"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}

export default CategoryModal;
